import { subscriptionService } from '../services'
import router from '../router'

const state = {
    subscription: {
        loading: false
    },
    plans: {
        loading: false,
        rows: []
    },
    createPlan: {
        loading: false,
    },
    createSubscriptionUrl: {
        loading: false,
        data: {}
    },
    plansSubscriptions: {
        data: {}
    },
    busy: false,
    ghostProducts: {
        rows: []
    },
    stripeProducts: [],
}

const actions = {

    getPlans ({ dispatch, commit }, params) {
        commit('getPlansRequest')
        subscriptionService.getPlans(params).then(
            response => {
                commit('getPlansSuccess', response)
            },
            error => {
                commit('getPlansError')
                dispatch('alert/error', 'Unable to load plans: ' + error, { root: true })
            }
        )
    },

    createPlan({ dispatch, commit }, params) {
        commit('startCreatePlanRequest')
        subscriptionService.createPlan(params).then(
            response => {
                commit('endCreatePlanRequest')
                if (params['id'] === null) {
                    dispatch('alert/success', 'New Plan created successfully', { root: true })
                } else {
                    dispatch('alert/success', 'Plan updated successfully', { root: true })
                }

                dispatch('getPlans', {})
            },
            error => {
                commit('endCreatePlanError')
                dispatch('alert/error', 'Unable to create new plan: ' + error, { root: true })
            }
        )
    },

    deletePlan({ dispatch, commit }, id) {
        commit('startCreatePlanRequest')
        subscriptionService.deletePlan(id).then(
            response => {
                commit('endCreatePlanRequest')
                dispatch('alert/success', 'Plan deleted successfully', { root: true })
                dispatch('getPlans', {})
            },
            error => {
                commit('endCreatePlanError')
                dispatch('alert/error', 'Unable to delete plan: ' + error, { root: true })
            }
        )
    },

    createSubscriptionUrl({ dispatch, commit }, params) {
        commit('startCreateSubscriptionRequest')
        return subscriptionService.createSubscriptionUrl(params).then(
            response => {
                commit('startCreateSubscriptionSuccess', response)
                dispatch('alert/success', `Subscription URL created successfully`, { root: true })
                return response
            },
            error => {
                commit('startCreateSubscriptionError')
                dispatch('alert/error', 'Unable to create subscription URL: ' + error, { root: true })
            }
        )
    },

    sendSubscriptionUrl({ dispatch, commit }, params) {
        commit('startRequest')
        return subscriptionService.sendSubscriptionUrl(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', `Email sent successfully`, { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to send email: ' + error, { root: true })
            }
        )
    },

    loadPlansSubscriptions({ dispatch, commit }, params) {
        commit('getPlansSubscriptionsRequest')
        return subscriptionService.getPlansSubscriptions(params).then(
            response => {
                commit('getPlansSubscriptionsSuccess', response)
                return response
            },
            error => {
                commit('getPlansSubscriptionsError')
                dispatch('alert/error', 'Unable to retrieve plans subscriptions: ' + error, { root: true })
            }
        )
    },

    savePlansSubscriptions({ dispatch, commit }, params) {
        commit('startRequest')
        subscriptionService.savePlansSubscriptions(params).then(
            response => {
                commit('endRequest', response)
                dispatch('alert/success', 'Plan Subscriptions updated successfully', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to save plans subscriptions: ' + error, { root: true })
            }
        )
    },

    getGhostProducts ({ dispatch, commit }) {
        commit('getGhostProductsRequest')
        return subscriptionService.getGhostProducts().then(
            response => {
                commit('getGhostProductsSuccess', response)
            },
            error => {
                commit('getGhostProductsError')
                dispatch('alert/error', 'Unable to load Ghost plans: ' + error, { root: true })
            }
        )
    },
    loadGhostProductsWithOther ({ dispatch, commit }) {
        commit('getGhostProductsRequest')
        return subscriptionService.loadGhostProductsWithOther().then(
            response => {
                commit('getGhostProductsSuccess', response)
            },
            error => {
                commit('getGhostProductsError')
                dispatch('alert/error', 'Unable to load Ghost plans: ' + error, { root: true })
            }
        )
    },
    createGhostPlan({ dispatch, commit }, params) {
        commit('startCreatePlanRequest')
        subscriptionService.createGhostPlan(params).then(
            response => {
                commit('endCreatePlanRequest')
                dispatch('alert/success', 'New Plan created successfully', { root: true })

                dispatch('getPlans', {})
            },
            error => {
                commit('endCreatePlanError')
                dispatch('alert/error', 'Unable to create new plan: ' + error, { root: true })
            }
        )
    },
    loadStripeProductsWithPlans ({ dispatch, commit }) {
        commit('loadStripeProductsRequest')
        return subscriptionService.loadStripeProductsWithPlans().then(
            response => {
                commit('loadStripeProductsSuccess', response)
            },
            error => {
                commit('loadStripeProductsError')
                dispatch('alert/error', 'Unable to load Stripe products: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    startRequest (state) {
        state.busy = { loading: true }
    },
    endRequest (state) {
        state.busy = { loading: false }
    },
    getPlansRequest (state) {
        state.plans = { loading: true, rows: [] }
    },
    getPlansSuccess (state, data) {
        state.plans = { loading: false, total: data.total, rows: data.plans }
    },
    getPlansError (state) {
        state.plans = { loading: false, total: 0, rows: [] }
    },
    startCreatePlanRequest (state) {
        state.createPlan = { loading: true }
    },
    endCreatePlanRequest (state) {
        state.createPlan = { loading: false }
    },
    endCreatePlanError (state) {
        state.createPlan = { loading: false }
    },
    startCreateSubscriptionRequest (state) {
        state.createSubscriptionUrl = { loading: true, data: {} }
    },
    startCreateSubscriptionSuccess (state, data) {
        state.createSubscriptionUrl = { loading: false, data: data.subscription }
    },
    startCreateSubscriptionError (state) {
        state.createSubscriptionUrl = { loading: false, data: {} }
    },
    getPlansSubscriptionsRequest (state) {
        state.busy = { loading: true }
        state.plansSubscriptions = { data: {} }
    },
    getPlansSubscriptionsSuccess (state, data) {
        state.busy = { loading: false }
        state.plansSubscriptions = { data: data.plansSubscriptions }
    },
    getPlansSubscriptionsError (state) {
        state.busy = {loading: false}
        state.plansSubscriptions = {data: {}}
    },
    getGhostProductsRequest(state) {
        state.busy = { loading: true }
    },
    getGhostProductsSuccess(state, data) {
        state.busy = { loading: false }
        state.ghostProducts.rows = data.products
    },
    getGhostProductsError(state) {
        state.busy = { loading: false }
    },
    loadStripeProductsRequest(state) {
        state.busy = { loading: true }
    },
    loadStripeProductsSuccess(state, data) {
        state.busy = { loading: false }
        state.stripeProducts = data.products
        state.ghostProducts.rows = data.products
    },
    loadStripeProductsError(state) {
        state.busy = { loading: false }
    },
}

const getters = {
    isLoadingPlans (state) {
        return state.plans.loading === true
    },
    getPlans (state) {
        return state.plans.rows
    },
    getPlansForSelect (state) {
        return [{
            'value': null,
            'text': 'Choose Offer'
        }].concat(state.plans.rows)
    },
    getPlansForSelectWithCreate (state) {
        return [{
            'value': null,
            'text': 'Choose Offer'
        }, {
            'value': '_create_new_plan_',
            'text': 'CREATE A NEW PLAN'
        }].concat(state.plans.rows)
    },
    getPlansLength (state) {
        return state.plans.rows.length
    },
    isBusy (state) {
        return state.createPlan.loading === true || state.plans.loading === true || state.createSubscriptionUrl.loading === true || state.busy.loading === true
    },
    isCreateSubscriptionUrlReady (state) {
        return !state.createSubscriptionUrl.loading && state.createSubscriptionUrl.data !== null
    },
    getCreateSubscriptionUrl (state) {
        return state.createSubscriptionUrl.data
    },
    getPlansSubscriptions (state) {
        return state.plansSubscriptions.data
    },
    getGhostProducts (state) {
        return state.ghostProducts.rows
    },
    getGhostProductPlansWithCreateOptions (state) {
        let options = [{
            label: 'Actions',
            items: [{
                    'value': '_create_new_plan_',
                    'text': 'CREATE A NEW PLAN'
                }
            ]
        }];

        for (const [idx, row] of Object.entries(state.ghostProducts.rows)) {
            let plan_options = []
            for (const [idx, plan] of Object.entries(row['plans'])) {
                const name = (plan.nickname ? plan.nickname : 'Price')
                const currency = plan.currency.toUpperCase()
                const intervalCount = plan.interval_count
                const baseAmount = plan.amount / 100
                const amount = plan.discounted_amount ? plan.discounted_amount / 100 : baseAmount
                let discount = ''

                let intervalDescription = plan.interval
                if (intervalCount > 1) {
                    intervalDescription = `every ${intervalCount} ${plan.interval}s`
                }

                if (plan.offer_description) {
                    discount = ` - (${baseAmount} ${currency}/${intervalDescription} - ${plan.offer_description})`
                }

                plan_options.push(
                    {
                        value: plan.id,
                        text: `${name} (${amount} ${currency}/${intervalDescription})${discount}`,
                        pricing: `${amount} ${currency}/${intervalDescription} ${discount}`,
                        interval: plan.interval,
                        intervalCount: plan.interval_count,
                    }
                );
            }
            options.push({
                label: row['product'].name,
                items: plan_options
            })
        }
        return options
    },
    getStripeProducts (state) {
        let items = [];
        for (const [idx, row] of Object.entries(state.stripeProducts)) {
            const product = row['product']
            items.push(
                {value: product.id, text: product.name},
            );
        }
        return items
    },
    getStripeOfferName: (state, getters) => (offerId) => {
        let offer = null

        getters.getGhostProductPlansWithCreateOptions.forEach((product) => {
            product.items.forEach((plan) => {
                if (plan.value === offerId) {
                    offer = plan
                }
            })
        })

        if (offer) {
            return offer.pricing
        } else if (offerId === 'offer_user_clicked') {
            return 'Offer User Clicked'
        } else {
            if (getters.getGhostProductPlansWithCreateOptions.length) {
                return 'No Offer'
            } else{
                return 'Loading...'
            }
        }
    }

}

const CURRENCIES = [
    {text: 'USD', value: 'usd'},
    {text: 'EUR', value: 'eur'},
    {text: 'CAD', value: 'cad'},
    {text: 'GBP', value: 'gbp'},
]

export const subscriptionModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    CURRENCIES
}
